import {
  Checkbox,
  Col,
  Divider,
  message,
  notification,
  Radio,
  Row,
} from "antd";
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  Date4,
  Select4,
  Text4,
  TextArea1,
} from "../../../Components/FormComponents/InputFields";
import { Controller, useForm } from "react-hook-form";
import {
  AddressDetailAPi,
  ContactDetailAPi,
  EducationDetailAPi,
  EmpOnboarding,
  getEmployeeDetailApi,
  KnowMyTeamAPI,
  uploadDocumentsAPI,
} from "../../../Services/EmployeeOnboarding";
import { useNavigate, useOutletContext } from "react-router-dom";
import {
  getEduColumnsConfig,
  getFamilyColumnsConfig,
  getEducationDocumentColumnsConfig,
  resolveEducationDocumentRule,
} from "./Component/ComlumnConfig";
import { Label } from "reactstrap";
import axios from "axios";
import { Section } from "lucide-react";
import dayjs from "dayjs";
import { PageLoader } from "../../../Services/PageLoader";
import CustomEditableCard from "./Component/IdentityTable";
import { MdKeyboardArrowDown } from "react-icons/md";

const defaultRelations = [{ label: 1 }];
const Education = [{ label: 1 }];

export default function PersonalDetails({ current, setCurrent }) {
  const {
    control,
    reset,
    handleSubmit,
    setValue,
    getValues,
    watch,
    formState: { errors, isValid },
  } = useForm({ mode: "onChange" });
  const { dropDowns, responseData, profileData, id } = useOutletContext();
  const formatLabel = (str) => {
    if (!str || typeof str !== "string") return str;
    if (str.toLowerCase() === "phd") return "PhD";
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const edudrop =
    (dropDowns &&
      dropDowns.EDUCATION?.map((item) => {
        const val = typeof item === "object" ? item.value : item;
        return {
          label: formatLabel(val),
          value: val,
        };
      })) ||
    [];

  const relationshipdrop =
    (dropDowns &&
      dropDowns.RELATIONSHIP?.map((item) => {
        const val = typeof item === "object" ? item.value : item;
        return {
          label: formatLabel(val),
          value: val,
        };
      })) ||
    [];
  const [disableFields, setDisabledFields] = useState("");

  const navigate = useNavigate(null);
  const [api, contextHolder] = notification.useNotification();

  const [output, setOutput] = useState(null);
  const [output2, setOutput2] = useState(null);

  const [tableData, setTableData] = useState(defaultRelations);
  const [tableData2, setTableData2] = useState(Education);

  const [isLoading, setIsLoading] = useState(false);
  const [aadharAddress, setAadharAddress] = useState(null);
  const [loading, setLoading] = useState(false);

  const isPanVerified = responseData?.pan_verified === true;
  const maritalStatus = watch("maritalStatus");
  const handleAddRow = () => {
    setTableData((prev) => [...prev, { label: prev.length + 1 }]);
  };

  const handleRemoveRow2 = (labelToRemove) => {
    setTableData2((prev) => prev.filter((row) => row.label !== labelToRemove));
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const [validationErrors, setValidationErrors] = useState([]);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const counter1 = useRef(0);

  function generateSimpleId1() {
    return (
      "id-" +
      (counter1.current++).toString(36) +
      "-" +
      Math.random().toString(36).slice(2, 5)
    );
  }

  const handleAddRow2 = () => {
    setTableData2((prev) => [
      ...prev,
      {
        label: generateSimpleId1(),
      },
    ]);
  };

  const handleRemoveRow = (labelToRemove) => {
    setTableData((prev) => prev.filter((row) => row.label !== labelToRemove));
  };
  const handleChangeValue = (value, field, relation) => {
    setOutput((prev) => ({
      ...prev,
      [relation]: {
        ...prev?.[relation],
        [field]: value,
      },
    }));
  };

  const handleChangeValue2 = (value, field, relation) => {
    setOutput2((prev) => ({
      ...prev,
      [relation]: {
        ...prev?.[relation],
        [field]: value,
        ...(field === "qualification"
          ? {
            tenth_certificate: null,
            twelfth_certificate: null,
            graduation_certificate: null,
            post_graduation_certificate: null,
            any_other: null,
          }
          : {}),
      },
    }));
  };
  console.log(relationshipdrop);
  const familycolumnsConfig = getFamilyColumnsConfig(
    handleChangeValue,
    relationshipdrop,
  );
  const educolumnsConfig = getEduColumnsConfig(handleChangeValue2, edudrop);
  const educationDocumentColumnsConfig =
    getEducationDocumentColumnsConfig(handleChangeValue2);
  const onSubmit = async (val) => {
    const vErrors = getValidationErrorMessages();
    if (vErrors.length > 0) {
      vErrors.forEach((err) => {
        api.error({
          message: "Validation Error",
          description: err,
          placement: "top",
        });
      });
      return;
    }

    if (responseData?.final_submit) {
      const enabledHandlers = [];

      if (disablePersonalDetails === false)
        enabledHandlers.push(handlePersonalDetailSubmit);
      if (disableContactDetails === false)
        enabledHandlers.push(handleContactDetailsSubmit);
      if (disableAddressDetails === false)
        enabledHandlers.push(handleAddressDetailsSubmit);
      if (disableEducationDetails === false)
        enabledHandlers.push(handleEducationDetailsSubmit);
      if (disableKnowMyTeam === false)
        enabledHandlers.push(handleKnowMyTeamSubmit);

      console.log(
        enabledHandlers,
        "event handler lskjdflaks",
        disablePersonalDetails,
        disableContactDetails,
        disableAddressDetails,
        disableEducationDetails,
        disableKnowMyTeam,
      );

      if (enabledHandlers.length === 1) {
        const success = await enabledHandlers[0](val);
        if (success !== false) {
          navigate("/new-user/identity-detail");
          handleSubmitFinal();
        }
        return;
      }

      for (const handler of enabledHandlers) {
        const success = await handler(val);
        if (!success) return;
      }
      handleSubmitFinal();
      navigate("/new-user/identity-detail");
    } else {
      const personal = await handlePersonalDetailSubmit(val);
      if (!personal) return;

      const contact = await handleContactDetailsSubmit(val);
      if (!contact) return;

      const address = await handleAddressDetailsSubmit(val);
      if (!address) return;

      const education = await handleEducationDetailsSubmit(val);
      if (!education) return;

      await handleKnowMyTeamSubmit(val);
    }
  };

  const handlePersonalDetailSubmit = async (val) => {
    const family_details = Object.values(output).map((item) => ({
      ...item,
    }));

    const payload = {
      title: val.title,
      full_name: val.full_name,
      dob: val.birthDate,
      gender: val.gender,
      height: val.height ? val.height : "",
      weight: val.weight ? val.weight : "",
      blood_group: val.bloodGroup,
      nationality: val.nationality ? val.nationality : "Indian",
      city: val.cityBirth ? val.cityBirth : "",
      state: val.stateBirth ? val.stateBirth : "",
      country: val.countryBirth,
      religion: val.religion ? val.religion : "",
      marital_status: val.maritalStatus,
      marriage_date: val.maritalStatus === "Married" ? val.marriageDate : null,
      family_details,
    };
    try {
      const { data } = await EmpOnboarding(payload);
      console.log(data, "chekcing datta");
      if (data?.success) {
        api.success({ message: data.message, placement: "top" });
        return true;
      } else {
        api.error({
          message: data.message,
          placement: "top",
        });
        return false;
      }
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  const handleContactDetailsSubmit = async (val) => {
    const payload = {
      mobile_number: val.mobilePrimary || "",
      alternate_mobile_number: val.alternateNumber || "",
      personal_email_id: val.personalEmail || "",
      work_email_id: val.workEmail || "",
      emergency_contact_name: val.emergencyContactName || "",
      emergency_contact_number: val.emergencyContactNumber || "",
      emergency_contact_relationship: val.emergencyContactRelationship || "",
    };

    try {
      const response = await ContactDetailAPi(payload);
      if (response?.data?.success) {
        api.success({ message: response?.data.message, placement: "top" });

        return true;
      } else {
        if (response?.data?.message === "Contact details already updated") {
          // handleAddressDetailsSubmit(val);
          return true;
        } else {
          api.error({
            message: response?.data.message,
            placement: "top",
          });
          return false;
        }

        return;
        // throw new Error("Submission failed: " + response?.data?.status);
      }
    } catch (error) {
      console.error("Failed to submit contact details:", error);
    }
  };

  const handleAddressDetailsSubmit = async (val) => {
    // const payload = {
    //   current_street: val.currentStreet || "",
    //   current_city: val.currentCity || "",
    //   current_state: val.currentState || "",
    //   current_pincode: val.currentPincode || "",
    //   permanent_street: val.permanentStreet || "",
    //   permanent_city: val.permanentCity || "",
    //   permanent_state: val.permanentState || "",
    //   permanent_pincode: val.permanentPincode || "",
    //   is_permanent_same: val.isPermanentSame === "Yes",
    //   pg_landlord_name: val.pgLandlordName || "",
    //   pg_contact_number: val.pgContactNumber || "",
    // };

    const payload = {
      // 🔹 Current Address
      current_street: val.currentStreet || "",
      current_city: val.currentCity || "",
      current_state: val.currentState || "",
      current_pincode: val.currentPincode || "",

      // 🔹 Permanent Address
      permanent_street: val.permanentStreet || "",
      permanent_city: val.permanentCity || "",
      permanent_state: val.permanentState || "",
      permanent_pincode: val.permanentPincode || "",

      // 🔥 NEW: Source tracking
      current_address_source: val.currentAddressSource || "manual",
      // "manual" | "aadhar"

      permanent_address_source: val.permanentAddressSource || "manual",
      // "manual" | "current" | "aadhar"

      // 🔥 NEW: Aadhaar Address
      aadhar_street: aadharAddress?.street || "",
      aadhar_city: aadharAddress?.city || "",
      aadhar_state: aadharAddress?.state || "",
      aadhar_pincode: aadharAddress?.pincode || "",

      // 🔹 PG Details
      pg_landlord_name: val.pgLandlordName || "",
      pg_contact_number: val.pgContactNumber || "",
    };

    try {
      const response = await AddressDetailAPi(payload);

      if (response?.data?.success) {
        // handleEducationDetailsSubmit(val);
        api.success({ message: response?.data.message, placement: "top" });
        return true;
      } else {
        if (response?.data?.message === "Address details already updated") {
          // handleEducationDetailsSubmit(val);
          return true;
        } else {
          api.error({
            message: response?.data.message,
            placement: "top",
          });
          return false;
        }

        // throw new Error("Submission failed: " + response?.data?.status);
      }
    } catch (error) {
      console.error("Failed to submit address details:", error);
    }
  };

  const handleEducationDetailsSubmit = async (val) => {
    const arrayOfValues = Object.values(output2);
    console.log(arrayOfValues, "checking arrayOfValues");
    if (arrayOfValues?.length > 0) {
      const education = arrayOfValues?.map((entry) => ({
        qualification: entry?.qualification || "",
        stream: entry?.stream || "",
        board: entry?.board || "",
        year_of_passing: entry?.year_of_passing || "",
        grade_cgpa: entry?.grade_cgpa || "",
        roll_no: entry?.roll_no || "",
      }));

      try {
        const { data } = await EducationDetailAPi(education);
        console.log(data);
        if (data?.success) {
          const documentFormData = new FormData();

          arrayOfValues.forEach((entry) => {
            const rule = resolveEducationDocumentRule(
              entry?.qualification || "",
            );
            const fileValue = entry?.[rule.key];
            const file = fileValue?.originFileObj || fileValue;

            if (file instanceof File) {
              // Newly selected file — send the binary only
              documentFormData.append(rule.key, file);
            }
            // Skip existing S3 URLs — backend already has them
          });

          if ([...documentFormData.entries()].length > 0) {
            const documentUploadResponse =
              await uploadDocumentsAPI(documentFormData);

            if (!documentUploadResponse?.data?.success) {
              api.error({
                message:
                  documentUploadResponse?.data?.message ||
                  "Education documents upload failed",
                placement: "top",
              });
              return false;
            }
          }

          // handleKnowMyTeamSubmit(val);
          api.success({ message: data.message, placement: "top" });
          return true;
        } else {
          api.error({
            message: data.message,
            placement: "top",
          });
          return false;
          // throw new Error("Failed with status " + data.status);
        }
      } catch (err) {
        console.error("Error submitting form:", err);
      }
    } else {
      api.error({
        message: "Education is Required please fill",
        placement: "top",
      });
    }
  };

  const handleKnowMyTeamSubmit = async (val) => {
    const payload = {
      nick_name: val.nick_name || "",
      native_place: val.native_place || "",
      favourite_movie: val.favourite_movie || "",
      favourite_actor: val.favourite_actor || "",
      favourite_cuisine: val.favourite_cuisine || "",
      like_to_do_most: val.like_to_do_most || "",
      hates_most: val.hates_most || "",
      role_model: val.role_model || "",
      favourite_song: val.favourite_song || "",
      life_best_Day: val.life_best_Day || "",
      philosophy_of_life: val.philosophy_of_life || "",
      struggle_of_life: val.struggle_of_life || "",
      favourite_place: val.favourite_place || "",
      dreams_of_life: val.dreams_of_life || "",
      makes_you_happy: val.makes_you_happy || "",
      makes_you_sad: val.makes_you_sad || "",
    };

    try {
      const res = await KnowMyTeamAPI(payload);
      if (res.data?.success) {
        console.log(responseData?.final_submit);
        if (responseData?.final_submit) {
          handleSubmitFinal();
        } else {
          navigate("/new-user/identity-detail");
        }
        api.success({ message: res?.data.message, placement: "top" });
      } else {
        api.error({
          message: res?.data.message,
          placement: "top",
        });
        throw new Error(
          "Submission failed: " + (res.data?.message || "Unknown error"),
        );
      }
    } catch (error) {
      console.error("Error submitting Know My Team form:", error);
    }
  };

  const handleSubmitFinal = async () => {
    const { data } = await axios.post("/api/employees/final-submit", {
      final_submit: true,
      sections: [
        "personal_details",
        "contact_details",
        "address_details",
        "education_details",
        "know_my_team",
      ],
    });

    if (data?.success) {
      api.success({
        message: data?.message,
        placement: "top",
      });
      navigate("/new-user/identity-detail");
    } else {
      api.error({
        message: data?.message,
        placement: "top",
      });
    }

    console.log("hellow");
  };

  const onError = (e) => {
    console.log(e);
  };

  const getPersonalDetail = async () => {
    // const responseData = await fetchDataDianamic("personal_details");
    // if (!responseData) return false;

    const personalDetails = responseData?.personal_details || {};
    const birth = responseData?.birth || {};
    const profile = profileData || {};
    const disableFields = {};

    const getValue = (path) => {
      const profileVal = path.reduce((acc, key) => acc?.[key], profile);
      const responseVal = path.reduce((acc, key) => acc?.[key], responseData);

      const fieldKey = path.join(".");

      if (
        profileVal !== undefined &&
        profileVal !== null &&
        profileVal !== ""
      ) {
        disableFields[fieldKey] = true;
        return profileVal;
      }

      return responseVal;
    };

    if (profile?.know_my_team) {
      Object.entries(profile.know_my_team).forEach(([key, val]) => {
        if (val !== undefined && val !== null && val !== "") {
          disableFields[`know_my_team.${key}`] = true;
        }
      });
    }

    const updatedValues = {
      title: getValue(["title"]),
      full_name: getValue(["name", "full_name"]),
      birthDate: getValue(["birth", "dob"]),
      gender: getValue(["gender"]),
      height: getValue(["personal_details", "height"]),
      weight: getValue(["personal_details", "weight"]),
      bloodGroup: getValue(["blood_group"]),
      nationality: getValue(["personal_details", "nationality"]),
      cityBirth: getValue(["birth", "place"]),
      stateBirth: getValue(["birth", "state"]),
      countryBirth: getValue(["birth", "country"]),
      religion: getValue(["personal_details", "religion"]),
      maritalStatus: getValue(["personal_details", "marital_status", "status"]),
      marriageDate:
        getValue(["personal_details", "marital_status", "status"]) === "Married"
          ? getValue(["personal_details", "marital_status", "marriage_date"])
          : null,
      mobilePrimary: getValue(["mobile"]),

      emergencyContactNumber: getValue([
        "contact_details",
        "emergency_contact_number",
      ]),
      emergencyContactName: getValue([
        "contact_details",
        "emergency_contact_name",
      ]),
      emergencyContactRelationship: getValue([
        "contact_details",
        "emergency_contact_relationship",
      ]),
      alternateNumber: getValue(["contact_details", "alternate_mobile_number"]),
      personalEmail: getValue(["email", "personal"]),
      workEmail: getValue(["email", "company"]),

      currentStreet: getValue(["address_details", "current_address", "street"]),
      currentCity: getValue(["address_details", "current_address", "city"]),
      currentState: getValue(["address_details", "current_address", "state"]),
      currentPincode: getValue([
        "address_details",
        "current_address",
        "pincode",
      ]),

      permanentStreet: getValue([
        "address_details",
        "permanent_address",
        "street",
      ]),
      permanentCity: getValue(["address_details", "permanent_address", "city"]),
      permanentState: getValue([
        "address_details",
        "permanent_address",
        "state",
      ]),
      permanentPincode: getValue([
        "address_details",
        "permanent_address",
        "pincode",
      ]),
      currentAddressSource:
        getValue(["address_details", "current_address", "source"]) || "manual",
      permanentAddressSource:
        getValue(["address_details", "permanent_address", "source"]) ||
        "manual",
      pgLandlordName: getValue([
        "address_details",
        "pg_details",
        "landlord_name",
      ]),

      pgContactNumber: getValue([
        "address_details",
        "pg_details",
        "contact_number",
      ]),

      // Spread know_my_team fields here (values will be taken from responseData)
      ...responseData?.know_my_team,
    };

    const educationList = responseData?.education_details?.education;
    const eduDocs = responseData?.documents?.educational_certificates || profileData?.documents?.educational_certificates || {};

    const educationValues = {};
    educationList?.forEach((item, index) => {
      const rowLabel = index + 1;
      Object.entries(item).forEach(([key, val]) => {
        educationValues[`${key}_${rowLabel}`] = val;
      });

      const rule = resolveEducationDocumentRule(item?.qualification || "");
      if (rule && eduDocs[rule.key]?.url) {
        educationValues[`${rule.key}_${rowLabel}`] = eduDocs[rule.key].url;
      }
    });

    const familyValues = {};
    let familyIndex = 1;
    Object.entries(personalDetails?.family_details || {}).forEach(([key, value]) => {
      if (key === "children") {
        (value || []).forEach((child) => {
          const rowLabel = familyIndex++;
          Object.entries(child).forEach(([k, v]) => {
            familyValues[`${k}_${rowLabel}`] = v;
          });
          familyValues[`relationship_${rowLabel}`] = String(child.relationship || "").toLowerCase();
        });
      } else {
        const rowLabel = familyIndex++;
        Object.entries(value).forEach(([k, v]) => {
          familyValues[`${k}_${rowLabel}`] = v;
        });
        familyValues[`relationship_${rowLabel}`] = String(key || "").toLowerCase();
      }
    });

    const familyState = {};
    let fIndex = 1;
    Object.entries(personalDetails?.family_details || {}).forEach(([key, value]) => {
      if (key === "children") {
        (value || []).forEach((child) => {
          familyState[fIndex++] = {
            ...child,
            relationship: String(child.relationship || "").toLowerCase(),
          };
        });
      } else {
        familyState[fIndex++] = {
          ...value,
          relationship: String(key || "").toLowerCase(),
        };
      }
    });
    setOutput(familyState);

    const educationState = {};
    educationList?.forEach((item, index) => {
      const rule = resolveEducationDocumentRule(item?.qualification || "");
      educationState[index + 1] = {
        ...item,
        ...(rule && eduDocs[rule.key]?.url ? { [rule.key]: eduDocs[rule.key].url } : {}),
      };
    });
    setOutput2(educationState);

    setDisabledFields(disableFields); // Set all disable flags before reset
    reset({ ...updatedValues, ...educationValues, ...familyValues });
    const aadhaarFromApi = responseData?.address_details?.aadhaar_address;

    if (aadhaarFromApi) {
      setAadharAddress({
        street: aadhaarFromApi.street,
        city: aadhaarFromApi.city,
        state: aadhaarFromApi.state,
        pincode: aadhaarFromApi.pincode,
      });
    }
  };

  const {
    personal_details_meta,
    contact_details_meta,
    education_details_meta,
    address_details_meta,
    know_my_team_meta,
  } = responseData?.final_submit || {};

  const is_Final_submit =
    personal_details_meta?.final_submit === true &&
    contact_details_meta?.final_submit === true &&
    education_details_meta?.final_submit === true &&
    address_details_meta?.final_submit === true &&
    know_my_team_meta?.final_submit === true;

  const shouldDisableFields = (sectionMeta) => {
    if (!sectionMeta) return false;
    return sectionMeta.final_submit === true;
  };

  const disablePersonalDetails = shouldDisableFields(personal_details_meta);
  const disableContactDetails = shouldDisableFields(contact_details_meta);
  const disableAddressDetails = shouldDisableFields(address_details_meta);
  const disableEducationDetails = shouldDisableFields(education_details_meta);
  const disableKnowMyTeam = shouldDisableFields(know_my_team_meta);

  const isFieldDisabled = (fieldName, sectionLocked) => {
    if (disableFields[fieldName]) return true;
    if (!sectionLocked) return false;

    const isFlagged = responseData?.flagged_fields?.some(
      (f) => f.id === fieldName
    );
    return !isFlagged;
  };

  // console.log(disablePersonalDetails,'personal detail',disableContactDetails,'disableContactDetails',disableAddressDetails,'disableAddressDetails',disableEducationDetails,'disableEducationDetails',disableKnowMyTeam,'checkign which is true')

  const fillAadharData = (aadhar) => {
    if (!aadhar) return;

    const genderMap = {
      M: "Male",
      F: "Female",
      O: "Other",
    };

    const addr = aadhar.address || {};

    const fullAddress = [
      addr.co,
      addr.loc,
      addr.vtc,
      addr.dist,
      addr.state,
      addr.pc,
      addr.country,
    ]
      .filter(Boolean)
      .join(", ");

    // 🔥 IMPORTANT: after reset only

    if (!isPanVerified) {
      setValue("full_name", aadhar.name);
      setValue("birthDate", dayjs(aadhar.dob, "DD-MM-YYYY"));
      setValue("gender", genderMap[aadhar.gender] || aadhar.gender);
    }
    // Address
    setAadharAddress({
      street: fullAddress,
      city: addr.dist,
      state: addr.state,
      pincode: addr.pc,
    });
  };

  const fetchemploymentData = async () => {
    try {
      // Disabled per request: avoid hitting surepass_fetch when navigating
      // to Personal Details via "Fill manually". If you need to re-enable,
      // uncomment the lines below.
      // const res = await axios.get(
      //   `/employee-connect/cb/surepass_fetch?mobile=${responseData?.mobile}`,
      // );
      // console.log(res.data.data);
      return false;
    } catch (err) {
      console.error("Digilocker API error:", err);
      return false;
    }
  };

  const fetchDigilockerData = async () => {
    try {
      const digilockerData = JSON.parse(
        localStorage.getItem("digilocker_data"),
      );

      const res = await axios.post(
        `/employee-connect/employee/surepass/digilocker/fetch`,
        {
          client_id: digilockerData?.request_id,
          aadhar_id: digilockerData?.aadhar_id,
        },
      );

      if (res?.data?.success) {
        const aadhar = res?.data?.data?.extracted_data?.aadhaar;

        if (aadhar) fillAadharData(aadhar);

        notification.success({
          message: "Digilocker data fetched successfully",
        });

        localStorage.removeItem("digilocker_data");

        return true; // ✅ success
      }

      return false; // ❌ fail
    } catch (err) {
      console.error("Digilocker API error:", err);
      return false;
    }
  };

  const type = localStorage.getItem("userType");
  const location = useLocation();

  useEffect(() => {
    if (responseData) {
      getPersonalDetail();

      // If the user navigated here from the "Fill manually" card we set
      // `location.state.digilocker_skip`. In that case we avoid calling
      // `fetchemploymentData()` which hits the surefetch endpoint and
      // may trigger Digilocker-related behaviour. This preserves the
      // user's choice to enter data manually while keeping any
      // `digilocker_data` in storage.
      const navSkip = location?.state?.digilocker_skip;
      if (!navSkip) {
        fetchemploymentData();
      }
    }
  }, [responseData, location]);

  const permanentAddressSource = watch("permanentAddressSource");
  const currentStreet = watch("currentStreet");
  const currentCity = watch("currentCity");
  const currentState = watch("currentState");
  const currentPincode = watch("currentPincode");

  // Watch all form values for comprehensive validation
  const allFormValues = watch();

  // Function to get validation error messages
  const getValidationErrorMessages = () => {
    const errors = [];

    // Check Basic Information
    if (!allFormValues.title) errors.push("• Title is required");
    if (!allFormValues.full_name) errors.push("• Full Name is required");
    if (!allFormValues.birthDate) errors.push("• Date of Birth is required");
    if (!allFormValues.cityBirth) errors.push("• City of Birth is required");
    if (!allFormValues.stateBirth) errors.push("• State of Birth is required");
    if (!allFormValues.countryBirth) errors.push("• Country of Birth is required");
    if (!allFormValues.bloodGroup) errors.push("• Blood Group is required");
    if (!allFormValues.gender) errors.push("• Gender is required");
    if (!allFormValues.nationality) errors.push("• Nationality is required");
    if (!allFormValues.maritalStatus) errors.push("• Marital Status is required");
    if (allFormValues.maritalStatus === "Married" && !allFormValues.marriageDate) {
      errors.push("• Date of Marriage is required");
    }

    // Check Contact Information
    if (!allFormValues.emergencyContactName) errors.push("• Emergency Contact Name is required");
    if (!allFormValues.emergencyContactRelationship) errors.push("• Emergency Contact Relationship is required");
    if (!allFormValues.emergencyContactNumber) errors.push("• Emergency Contact Number is required");

    // Check Current Address
    if (!allFormValues.currentStreet) errors.push("• Current Residential Address is required");
    if (!allFormValues.currentCity) errors.push("• Current City is required");
    if (!allFormValues.currentState) errors.push("• Current State is required");
    if (!allFormValues.currentPincode) errors.push("• Current Pincode is required");

    // Check Permanent Address (if not same as current)
    if (permanentAddressSource !== "current") {
      if (!allFormValues.permanentStreet) errors.push("• Permanent Address is required");
      if (!allFormValues.permanentCity) errors.push("• Permanent City is required");
      if (!allFormValues.permanentState) errors.push("• Permanent State is required");
      if (!allFormValues.permanentPincode) errors.push("• Permanent Pincode is required");
    }

    // Check Family Details
    if (!output || Object.keys(output).length === 0) {
      errors.push("• At least one Family Member is required");
    } else {
      for (const familyMember of Object.values(output)) {
        if (!familyMember.name || !familyMember.dob || !familyMember.relationship || !familyMember.nationality) {
          errors.push("• Please fill all Family Member details (Name, DOB, Relationship, Nationality)");
          break;
        }
      }
    }

    // Check Education Details
    if (!output2 || Object.keys(output2).length === 0) {
      errors.push("• At least one Education Entry is required");
    } else {
      for (const education of Object.values(output2)) {
        if (!education.qualification || !education.stream || !education.board ||
          !education.year_of_passing || !education.grade_cgpa) {
          errors.push("• Please fill all Education details (Qualification, Stream, Board, Year, Grade/CGPA)");
          break;
        }

        const rule = resolveEducationDocumentRule(education.qualification || "");
        if (rule && !education[rule.key]) {
          errors.push(`• Document Upload (${rule.title}) is required for ${education.qualification}`);
          break;
        }
      }
    }

    return errors;
  };

  // Comprehensive validation function to check if all required fields are filled
  const isAllFieldsValid = () => {
    return getValidationErrorMessages().length === 0;
  };

  // Update validation errors whenever form values change
  useEffect(() => {
    setValidationErrors(getValidationErrorMessages());
  }, [allFormValues, isValid, output, output2, permanentAddressSource]);

  useEffect(() => {
    if (permanentAddressSource === "current") {
      setValue("permanentStreet", currentStreet, { shouldValidate: true });
      setValue("permanentCity", currentCity, { shouldValidate: true });
      setValue("permanentState", currentState, { shouldValidate: true });
      setValue("permanentPincode", currentPincode, { shouldValidate: true });
    } else if (permanentAddressSource === "aadhar" && aadharAddress) {
      setValue("permanentStreet", aadharAddress.street, {
        shouldValidate: true,
      });
      setValue("permanentCity", aadharAddress.city, { shouldValidate: true });
      setValue("permanentState", aadharAddress.state, { shouldValidate: true });
      setValue("permanentPincode", aadharAddress.pincode, {
        shouldValidate: true,
      });
    }
  }, [
    permanentAddressSource,
    currentStreet,
    currentCity,
    currentState,
    currentPincode,
    aadharAddress,
    setValue,
  ]);


  useEffect(() => {
    // Polling loop for Digilocker: only run when there is an active
    // `digilocker_data` in localStorage AND the navigation hasn't
    // explicitly asked to skip Digilocker (e.g. user chose Fill manually).
    //
    // This loop posts to the server to fetch Digilocker results and sets
    // `loading` while polling. It will stop after a timeout.
    const navSkip = location?.state?.digilocker_skip;
    if (navSkip) return;

    const digilockerData = JSON.parse(localStorage.getItem("digilocker_data"));
    if (!digilockerData?.request_id) return;

    let isMounted = true;

    const pollDigilocker = async () => {
      setLoading(true);

      const startTime = Date.now();
      const MAX_TIME = 90000; // 90 sec
      const INTERVAL = 10000; // 10 sec

      while (Date.now() - startTime < MAX_TIME) {
        const success = await fetchDigilockerData();

        if (success) {
          setLoading(false);
          return;
        }

        // wait before retry
        await new Promise((resolve) => setTimeout(resolve, INTERVAL));
      }

      // timeout casek
      if (isMounted) {
        setLoading(false);
        notification.error({
          message: "Digilocker taking too long. Please try again.",
        });
      }
    };

    pollDigilocker();

    return () => {
      isMounted = false;
    };
  }, [location]);

  useEffect(() => {
    if (aadharAddress) {
      setValue("aadharStreet", aadharAddress.street);
      setValue("aadharCity", aadharAddress.city);
      setValue("aadharState", aadharAddress.state);
      setValue("aadharPincode", aadharAddress.pincode);
    }
  }, [aadharAddress]);

  return (
    <>
      {contextHolder}
      {true && <PageLoader loading={loading} />}
      <h3 className="color-heading mb-4">Personal Details</h3>

      <form className="h-full" onSubmit={handleSubmit(onSubmit, onError)}>
        <div className=" border rounded-xl bg-white shadow-md">
          <div
            className="flex justify-between items-center px-4 py-3 border rounded-t-xl cursor-pointer"
            onClick={() => toggleAccordion(0)}
          >
            <h3 className="color-heading2">BASIC INFORMATION</h3>

            <MdKeyboardArrowDown
              size={35}
              className={`transition-transform duration-300 ${activeIndex === 0 ? "rotate-180" : ""
                }`}
            />
          </div>
          {activeIndex === 0 && (
            <div className={`transition-all duration-300 overflow-hidden p-4`}>
              <Row className="align-content-start  w-full ">
                <Select4
                  control={control}
                  errors={errors}
                  id="title"
                  name="Title"
                  disabled={isFieldDisabled("title", disablePersonalDetails)}
                  validations={{
                    required: true,
                    message: "Title is required",
                  }}
                  options={[
                    { label: "Mr", value: "mr" },
                    { label: "Ms", value: "ms" },
                    { label: "Mrs", value: "mrs" },
                  ]}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="full_name"
                  name="Full Name (as per Aadhar)"
                  disabled={
                    isFieldDisabled("name.full_name", disablePersonalDetails) ||
                    isPanVerified
                  }
                  validations={{
                    required: true,
                    message: "Full name is required",
                  }}
                />

                <Date4
                  control={control}
                  errors={errors}
                  id="birthDate"
                  name="Date of Birth"
                  disabled={
                    isFieldDisabled("birth.dob", disablePersonalDetails) ||
                    isPanVerified
                  }
                  validations={{
                    required: true,
                    message: "Date of Birth is required",
                  }}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="cityBirth"
                  name="City of Birth"
                  disabled={isFieldDisabled("birth.place", disablePersonalDetails)}
                  validations={{
                    required: true,
                    message: "City of Birth is required",
                  }}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="stateBirth"
                  name="State of Birth"
                  disabled={isFieldDisabled("birth.state", disablePersonalDetails)}
                  validations={{
                    required: true,
                    message: "State of Birth is required",
                  }}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="countryBirth"
                  name="Country of Birth"
                  disabled={isFieldDisabled("birth.country", disablePersonalDetails)}
                  validations={{
                    required: true,
                    message: "Country of Birth is required",
                  }}
                />
                <Select4
                  control={control}
                  errors={errors}
                  id="bloodGroup"
                  disabled={isFieldDisabled("blood_group", disablePersonalDetails)}
                  name="Blood Group"
                  validations={{
                    required: true,
                    message: "Blood Group is required",
                  }}
                  options={dropDowns && dropDowns.BLOOD_GROUP}
                />
                <Select4
                  control={control}
                  errors={errors}
                  id="gender"
                  name="Gender"
                  disabled={
                    isFieldDisabled("gender", disablePersonalDetails) ||
                    isPanVerified
                  }
                  options={[
                    { label: "Male", value: "male" },
                    { label: "Female", value: "female" },
                  ]}
                  validations={{
                    required: true,
                    message: "Gender is required",
                  }}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="nationality"
                  name="Nationality"
                  disabled={isFieldDisabled(
                    "personal_details.nationality",
                    disablePersonalDetails,
                  )}
                  validations={{
                    required: true,
                    message: "Nationality is required",
                  }}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="religion"
                  name="Religion"
                  disabled={isFieldDisabled(
                    "personal_details.religion",
                    disablePersonalDetails,
                  )}
                />
                <Select4
                  control={control}
                  errors={errors}
                  id="maritalStatus"
                  name="Marital status"
                  disabled={isFieldDisabled(
                    "personal_details.marital_status.status",
                    disablePersonalDetails,
                  )}
                  options={[
                    { label: "Married", value: "Married" },
                    { label: "Unmarried", value: "Unmarried" },
                  ]}
                  validations={{
                    required: true,
                    message: "Marital Status is required",
                  }}
                />
                {maritalStatus === "Married" && (
                  <Date4
                    control={control}
                    errors={errors}
                    id="marriageDate"
                    disabled={isFieldDisabled(
                      "personal_details.marital_status.marriage_date",
                      disablePersonalDetails,
                    )}
                    name="Date of Marriage"
                    validations={{
                      required: true,
                      message: "Date Of Marriage is required",
                    }}
                  />
                )}
              </Row>
            </div>
          )}
        </div>

        <div className=" border rounded-xl bg-white shadow-md mt-5">
          <div
            className="flex justify-between items-center px-4 py-3 border rounded-t-xl cursor-pointer"
            onClick={() => toggleAccordion(1)}
          >
            <h3 className="color-heading2"> FAMILY INFORMATION</h3>

            <MdKeyboardArrowDown
              size={35}
              className={`transition-transform duration-300 ${activeIndex === 1 ? "rotate-180" : ""
                }`}
            />
          </div>
          {activeIndex === 1 && (
            <div className={`transition-all duration-300 overflow-hidden p-4`}>
              <div className=" w-full mb-4 px-2">
                <CustomEditableCard
                  control={control}
                  errors={errors}
                  handleAddRow={handleAddRow}
                  handleRemoveRow={handleRemoveRow}
                  columnsConfig={familycolumnsConfig}
                  tableData={tableData}
                  setTableData={setTableData}
                  output={output}
                  setOutput={setOutput}
                  isLoading={isLoading}
                  allDisabled={disablePersonalDetails}
                  flaggedFields={responseData?.flagged_fields}
                  rowTitle={(record, index) => `Member #${index + 1}`}
                />
              </div>
            </div>
          )}
        </div>

        <div className=" border rounded-xl bg-white shadow-md mt-5">
          <div
            className="flex justify-between items-center px-4 py-3 border rounded-t-xl cursor-pointer"
            onClick={() => toggleAccordion(2)}
          >
            <h3 className="color-heading2">CONTACT INFORMATION</h3>

            <MdKeyboardArrowDown
              size={35}
              className={`transition-transform duration-300 ${activeIndex === 2 ? "rotate-180" : ""
                }`}
            />
          </div>
          {activeIndex === 2 && (
            <div className={`transition-all duration-300 overflow-hidden p-4`}>
              <Row className="align-content-start  w-full ">
                {/* <Text4
            control={control}
            errors={errors}
            id="mobilePrimary"
            disabled={disableFields["mobile"] || disableContactDetails}
            name="Mobile Number (Primary)"
            type="number"
            validations={{
              required: false,
              pattern: {
                value: /^\d{10}$/,
                message: "Number must be exactly 10 digits",
              },
            }}
            maxLength={10}
          /> */}

                <Text4
                  control={control}
                  errors={errors}
                  id="alternateNumber"
                  type="number"
                  name="Alternate Number"
                  disabled={isFieldDisabled(
                    "contact_details.alternate_mobile_number",
                    disableContactDetails,
                  )}
                  validations={{
                    required: false,
                    pattern: {
                      value: /^\d{10}$/,
                      message: "Number must be exactly 10 digits",
                    },
                  }}
                  maxLength={10}
                />

                {/* <Text4
            control={control}
            errors={errors}
            id="personalEmail"
            name="Personal Email Id"
            disabled={disableFields["email.personal"] || disableContactDetails}
            validations={{
              required: false,
            }}
          />

          <Text4
            control={control}
            errors={errors}
            id="workEmail"
            name="Work Email Id"
            disabled={disableFields["email.company"] || disableContactDetails}
          /> */}

                <Text4
                  control={control}
                  errors={errors}
                  id="emergencyContactName"
                  name="Emergency Contact Name"
                  validations={{
                    required: true,
                    message: "Emergency Contact Name is required",
                  }}
                  disabled={isFieldDisabled(
                    "contact_details.emergency_contact_name",
                    disableContactDetails,
                  )}
                />

                <Text4
                  control={control}
                  errors={errors}
                  id="emergencyContactRelationship"
                  name="Emergency Contact Relationship"
                  disabled={isFieldDisabled(
                    "contact_details.emergency_contact_relationship",
                    disableContactDetails,
                  )}
                  validations={{
                    required: true,
                    message: "Emergency Contact Relationship is required",
                  }}
                />

                <Text4
                  control={control}
                  errors={errors}
                  id="emergencyContactNumber"
                  name="Emergency Contact Number"
                  maxLength={10}
                  disabled={isFieldDisabled(
                    "contact_details.emergency_contact_number",
                    disableContactDetails,
                  )}
                  validations={{
                    required: true,
                    pattern: {
                      value: /^\d{10}$/,
                      message: "Number must be exactly 10 digits",
                    },
                  }}
                />

                {aadharAddress && (
                  <>
                    <Col className="px-3 mt-4 text-justify" span={24}>
                      <h2 className="text-[#00a0e4] font-bold text-xl flex items-center">
                        <span className="w-1 h-full bg-[#00a0e4] mr-2">|</span>
                        Aadhaar Address (Verified)
                      </h2>
                    </Col>

                    <TextArea1
                      control={control}
                      errors={errors}
                      id="aadharStreet"
                      name="Aadhaar Address"
                      disabled
                    />

                    <Text4
                      control={control}
                      errors={errors}
                      id="aadharCity"
                      name="City"
                      disabled
                    />

                    <Text4
                      control={control}
                      errors={errors}
                      id="aadharState"
                      name="State"
                      disabled
                    />

                    <Text4
                      control={control}
                      errors={errors}
                      id="aadharPincode"
                      name="Pincode"
                      disabled
                    />
                  </>
                )}

                <Col className="px-3 mt-4 text-justify" span={24}>
                  <h2 className="text-[#00a0e4] font-bold text-xl flex items-center">
                    <span className="w-1 h-full bg-[#00a0e4] mr-2">|</span>
                    Current Address Details
                  </h2>
                </Col>

                {aadharAddress && (
                  <Col className={`px-3 py-3`} lg={6} sm={12} xs={24}>
                    <Row
                      className="align-items-end position-relative"
                      style={{ height: "100%", width: "100%" }}
                    >
                      {aadharAddress && (
                        <Controller
                          control={control}
                          name="currentAddressSource"
                          render={({ field }) => {
                            const isDisabled = disableAddressDetails;

                            return (
                              <Checkbox
                                checked={field.value === "aadhar"}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  const value = checked ? "aadhar" : "manual";
                                  field.onChange(value);

                                  if (checked && aadharAddress) {
                                    // Copy Aadhaar → Current
                                    setValue(
                                      "currentStreet",
                                      aadharAddress.street,
                                      { shouldValidate: true },
                                    );
                                    setValue("currentCity", aadharAddress.city, {
                                      shouldValidate: true,
                                    });
                                    setValue(
                                      "currentState",
                                      aadharAddress.state,
                                      { shouldValidate: true },
                                    );
                                    setValue(
                                      "currentPincode",
                                      aadharAddress.pincode,
                                      { shouldValidate: true },
                                    );
                                  } else {
                                    // Clear for manual input
                                    setValue("currentStreet", "", {
                                      shouldValidate: true,
                                    });
                                    setValue("currentCity", "", {
                                      shouldValidate: true,
                                    });
                                    setValue("currentState", "", {
                                      shouldValidate: true,
                                    });
                                    setValue("currentPincode", "", {
                                      shouldValidate: true,
                                    });
                                  }
                                }}
                                disabled={isDisabled}
                              >
                                Same as Aadhaar
                              </Checkbox>
                            );
                          }}
                        />
                      )}
                    </Row>
                  </Col>
                )}

                <TextArea1
                  control={control}
                  errors={errors}
                  id="currentStreet"
                  name="Current Residential Address"
                  placeholder="Enter Street"
                  validations={{ required: true }}
                  disabled={isFieldDisabled(
                    "address_details.current_address.street",
                    disableAddressDetails,
                  )}
                />
                <Text4
                  control={control}
                  errors={errors}
                  disabled={isFieldDisabled(
                    "address_details.current_address.city",
                    disableAddressDetails,
                  )}
                  validations={{ required: true }}
                  id="currentCity"
                  name="City"
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="currentState"
                  name="State"
                  validations={{ required: true }}
                  disabled={isFieldDisabled(
                    "address_details.current_address.state",
                    disableAddressDetails,
                  )}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="currentPincode"
                  name="Pincode"
                  validations={{
                    required: true,
                  }}
                  disabled={isFieldDisabled(
                    "address_details.current_address.pincode",
                    disableAddressDetails,
                  )}
                />
              </Row>

              <Col className="px-3 mt-4 text-justify" span={24}>
                <h2 className="text-[#00a0e4] font-bold text-xl flex items-center">
                  <span className="w-1 h-full bg-[#00a0e4] mr-2">|</span>
                  Permanent Address Details
                </h2>
              </Col>

              <Row className="align-content-start  w-full ">
                <Col className={`px-3 py-3 `} lg={24} sm={24} xs={24}>
                  <Row
                    className="align-items-end position-relative"
                    style={{ height: "100%", width: "100%", gap: "20px" }}
                  >
                    <Controller
                      control={control}
                      name="permanentAddressSource"
                      render={({ field }) => {
                        const isDisabled = disableAddressDetails;

                        return (
                          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            {aadharAddress && (
                              <Checkbox
                                checked={field.value === "aadhar"}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  field.onChange(checked ? "aadhar" : "manual");
                                }}
                                disabled={isDisabled}
                              >
                                Same as Aadhaar
                              </Checkbox>
                            )}
                            <Checkbox
                              checked={field.value === "current"}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                field.onChange(checked ? "current" : "manual");
                              }}
                              disabled={isDisabled}
                            >
                              Permanent address is same as current address
                            </Checkbox>
                          </div>
                        );
                      }}
                    />
                  </Row>
                </Col>
              </Row>
              {watch("permanentAddressSource") === "manual" && (
                <Row className="align-content-start  w-full ">
                  <TextArea1
                    control={control}
                    errors={errors}
                    id="permanentStreet"
                    name="Permanent Address"
                    validations={{ required: true }}
                    placeholder="Enter Street"
                    disabled={isFieldDisabled(
                      "address_details.permanent_address.street",
                      disableAddressDetails,
                    )}
                  />
                  <Text4
                    control={control}
                    errors={errors}
                    id="permanentCity"
                    name="City"
                    validations={{ required: true }}
                    disabled={isFieldDisabled(
                      "address_details.permanent_address.city",
                      disableAddressDetails,
                    )}
                  />
                  <Text4
                    control={control}
                    errors={errors}
                    id="permanentState"
                    name="State"
                    validations={{ required: true }}
                    disabled={isFieldDisabled(
                      "address_details.permanent_address.state",
                      disableAddressDetails,
                    )}
                  />
                  <Text4
                    control={control}
                    errors={errors}
                    id="permanentPincode"
                    name="Pincode"
                    validations={{
                      required: true,
                    }}
                    disabled={isFieldDisabled(
                      "address_details.permanent_address.pincode",
                      disableAddressDetails,
                    )}
                  />
                </Row>
              )}
            </div>
          )}
        </div>

        <div className=" border rounded-xl bg-white shadow-md mt-5">
          <div
            className="flex justify-between items-center px-4 py-3 border rounded-t-xl cursor-pointer"
            onClick={() => toggleAccordion(3)}
          >
            <h3 className="color-heading2"> EDUCATION INFORMATION</h3>

            <MdKeyboardArrowDown
              size={35}
              className={`transition-transform duration-300 ${activeIndex === 3 ? "rotate-180" : ""
                }`}
            />
          </div>
          {activeIndex === 3 && (
            <div className={`transition-all duration-300 overflow-hidden p-4`}>
              <div className=" w-full mb-4 px-2">
                <CustomEditableCard
                  control={control}
                  errors={errors}
                  handleAddRow={handleAddRow2}
                  handleRemoveRow={handleRemoveRow2}
                  columnsConfig={educolumnsConfig}
                  documentColumnsConfig={educationDocumentColumnsConfig}
                  tableData={tableData2}
                  setTableData={setTableData2}
                  output={output2}
                  setOutput={setOutput2}
                  isLoading={isLoading}
                  allDisabled={disableEducationDetails}
                  flaggedFields={responseData?.flagged_fields}
                  rowTitle={(record, index) => `Qualification #${index + 1}`}
                />
              </div>
            </div>
          )}
        </div>

        <div className=" border rounded-xl bg-white shadow-md mt-5">
          <div
            className="flex justify-between items-center px-4 py-3 border rounded-t-xl cursor-pointer"
            onClick={() => toggleAccordion(4)}
          >
            <h3 className="color-heading2"> KNOW MY TEAM (Optional)</h3>

            <MdKeyboardArrowDown
              size={35}
              className={`transition-transform duration-300 ${activeIndex === 4 ? "rotate-180" : ""
                }`}
            />
          </div>
          {activeIndex === 4 && (
            <div className={`transition-all duration-300 overflow-hidden p-4`}>
              <Row className="align-content-start  w-full ">
                <Text4
                  control={control}
                  errors={errors}
                  id="nick_name"
                  name="Nick Name"
                  disabled={disableFields["know_my_team.nick_name"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="native_place"
                  name="Native Place"
                  disabled={disableFields["know_my_team.native_place"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="favourite_movie"
                  name="Favourite Movie"
                  disabled={disableFields["know_my_team.favourite_movie"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="favourite_actor"
                  name="Favourite Actress/Actor"
                  disabled={disableFields["know_my_team.favourite_actor"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="favourite_cuisine"
                  name="Favourite Cuisine"
                  disabled={disableFields["know_my_team.favourite_cuisine"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="like_to_do_most"
                  name="Like to do most"
                  disabled={disableFields["know_my_team.like_to_do_most"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="hates_most"
                  name="Hates most"
                  disabled={disableFields["know_my_team.hates_most"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="role_model"
                  name="Role Model"
                  disabled={disableFields["know_my_team.role_model"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="favourite_song"
                  name="Favourite Song"
                  disabled={disableFields["know_my_team.favourite_song"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="life_best_Day"
                  name="Life's Best Day"
                  disabled={disableFields["know_my_team.life_best_Day"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="philosophy_of_life"
                  name="Philosophy of Life"
                  disabled={disableFields["know_my_team.philosophy_of_life"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="struggle_of_life"
                  name="Struggle of Life"
                  disabled={disableFields["know_my_team.struggle_of_life"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="favourite_place"
                  name="Favourite Places"
                  disabled={disableFields["know_my_team.favourite_place"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="dreams_of_life"
                  name="Dreams of Life"
                  disabled={disableFields["know_my_team.dreams_of_life"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="makes_you_happy"
                  name="What makes you Happy"
                  disabled={disableFields["know_my_team.makes_you_happy"] || disableKnowMyTeam}
                />
                <Text4
                  control={control}
                  errors={errors}
                  id="makes_you_sad"
                  name="What makes you Sad"
                  disabled={disableFields["know_my_team.makes_you_sad"] || disableKnowMyTeam}
                />
              </Row>
            </div>
          )}
        </div>



        <Row className="step-buttons-box justify-content-end pt-3" style={{ borderTop: '1px solid #e5e7eb' }}>
          {type !== "admin" && (
            <>
              <button
                disabled={
                  (is_Final_submit && !responseData?.flagged_fields?.length) ||
                  loading
                }
                className="my-2 text-white step-button"
                type="submit"
                title={validationErrors.length > 0 ? `Please fill all required fields: ${validationErrors.join(', ')}` : "Save & Continue"}
              >
                {loading ? "Processing..." : "Save & Continue"}
              </button>
            </>
          )}{" "}
        </Row>
      </form>
    </>
  );
}
